module.exports = __webpack_public_path__ + "img/new_4.791337e1.png";